import React from "react";
import { Minus, Plus } from "lucide-react";

export function Stepper({ value, onChange, min = 1, max = 99, size = 36, testId }) {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  const dim = { width: size, height: size };
  return (
    <div className="inline-flex items-center gap-2" data-testid={testId}>
      <button
        type="button"
        onClick={dec}
        disabled={value <= min}
        style={dim}
        className="flex items-center justify-center rounded-full bg-hm-tertiary text-hm-ink transition-colors hover:bg-hm-lineStrong disabled:opacity-40"
        data-testid={testId ? `${testId}-dec` : undefined}
        aria-label="decrease"
      >
        <Minus size={16} />
      </button>
      <span className="min-w-[24px] text-center font-sans text-lg font-bold text-hm-ink" data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </span>
      <button
        type="button"
        onClick={inc}
        disabled={value >= max}
        style={dim}
        className="flex items-center justify-center rounded-full bg-hm-brand text-white transition-colors hover:opacity-90 disabled:opacity-40"
        data-testid={testId ? `${testId}-inc` : undefined}
        aria-label="increase"
      >
        <Plus size={16} />
      </button>
    </div>
  );
}
